import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Forms } from "../../shared/classes/formModel";
import { EcommerceForm } from "../../shared/classes/ecommerceModel";
import { UUID } from "angular2-uuid";
import { HttpClient } from "@angular/common/http";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { wfsService } from "src/app/shared/services/wfs.service";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { FileUploadService } from "src/app/shared/services/fileupload.service";
@Component({
  selector: "app-add-form",
  templateUrl: "./add-form.component.html",
  styleUrls: ["./add-form.component.sass"],
})
export class AddFormComponent implements OnInit {
  type: string = "save";
  showList: boolean = true;
  globalImgUrl: any;
  groupName: any;
  registerIcon: any;
  registerGroup: FormGroup;
  formsArray = [];
  regLanguage: string = "";
  editRow: any[] = [];
  kpiName: string;
  showKpiName: boolean = false;
  tableName: any;
  showKpiNameUpdate = [];
  kpinameHead: boolean;
  previousPage: number;
  skip: number;
  collectionSize: number;
  page = 1;
  showReg: boolean = true;
  typeId: string = "dynamic";
  selctedReg: string = "";
  editRowIndex: number;
  index: number;
  disableFormsBtn: boolean = false;
  selectedUUID: string = "";
  isFormBtn: any[] = [];
  showSavebtn: boolean;
  form: Forms[];
  workFlow: EcommerceForm;
  workFlowName: string;
  showAddform: boolean = false;
  showAdd: boolean = true;
  formTable: boolean = false;
  imageUploadService: any;
  url = "";
  tableArray: any[];
  languageList: any = [];
  showStepper: boolean = false;
  registerFormObj = {};
  // registerFormUpdateObj: {
  //   orderId: number;
  //   ask: string;
  //   type: string;
  //   mandatory: boolean;
  //   kpiName?: string;
  //   className?: any;
  //   formName?: any;
  //   btnMetaData?: any;
  //   repeatCount?: number;
  //   tableView?: boolean;
  // };
  registerFormUpdateObj: any = {};
  loading: boolean;
  workflows: any[] = [];
  className: any;
  workFlowDescription: string;
  classesList = [];
  btnLoading: boolean = false;
  btnDone: boolean = false;
  showFormInput: boolean = false;
  members: any;
  formId: any;
  version: any;
  selectedClass: any;
  tempArray = [];
  selectedClassId: any;
  selectedClassVersion: any;
  selectedListId: any;
  selectedMember: any;
  draftFormsList: any[] = [];
  activeFormsList: any[];
  showDraftForms: boolean;
  showActiveStepper: boolean = false;
  showDraftStepper: boolean = false;
  selectedRec: any;
  formsList = [];
  versionsList: any[] = [];
  showViewBtn: any[] = [];
  showVersionDropdown: any[] = [];
  readOnly: boolean = false;
  versionUuid: any;
  showClassInput: boolean = true;
  showButtonInput: boolean = false;
  enableView: boolean = false;
  showRepeatCount: boolean = false;
  formName: any;
  innerFormName: any;
  showIterativeForm: boolean = false;
  selectedInnerForm: any;
  selectedInnerFormId: any;
  selectedInnerFormVersion: any;
  selectedList: any;
  showParameter: boolean = false;
  listOptions = [];
  listGenerated: boolean = false;
  editLoading: any;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private fileUploadService: FileUploadService,
    private wfsService: wfsService,
    public http: HttpClient,
    private cognitoService: CognitoService
  ) { }
  async ngOnInit() {
    this.globalImgUrl = this.authService.s3url();
    await this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.getAllClasses();
    });
    this.languageList = [
      { languageName: "Bengali", shortName: "BN" },
      { languageName: "English", shortName: "EN" },
      { languageName: "Gujarati", shortName: "GU" },
      { languageName: "Hindi", shortName: "HI" },
      { languageName: "Kannada", shortName: "KN" },
      { languageName: "Marathi", shortName: "MR" },
      { languageName: "Malayalam", shortName: "ML" },
      { languageName: "Odia", shortName: "OR" },
      { languageName: "Punjabi", shortName: "PA" },
      { languageName: "Tamil", shortName: "TA" },
      { languageName: "Telugu", shortName: "TE" },
      { languageName: "Urdu", shortName: "UR" },
    ];
    this.registerGroup = this.formBuilder.group({
      orderId: ["", Validators.required],
      ask: ["", Validators.required],
      type: ["", Validators.required],
      kpiName: ["", Validators.required],
      mandatory: ["", Validators.required],
      tableView: [""],
      className: [""],
      memberName: [""],
      repeatCount: [""],
      form: [""],
      parameterName: [],
    });
    this.getAllActiveForms();
    this.getAllDraftForms();
    this.getAllClasses();
  }
  getAllActiveForms() {
    this.activeFormsList = [];
    this.workflows = [];
    this.loading = true;
    this.showDraftForms = false;
    let obj = {
      group: this.groupName,
    };
    this.wfsService.getECFormsPublish(obj).then((data: any) => {
      if (data.length > 0) {
        this.activeFormsList = data;
        this.workflows = this.activeFormsList;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  getAllDraftForms() {
    this.loading = true;
    this.workflows = [];
    this.showDraftForms = true;
    let obj = {
      group: this.groupName,
    };
    this.wfsService.getECFormsDraft(obj).then((data: any) => {
      if (data) {
        this.draftFormsList = [];
        this.draftFormsList = data;
        this.workflows = this.draftFormsList;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  showFormVersions(index) {
    this.selectedRec = this.workflows[index];
    this.closeVersionDropdown(index);
    this.getFormVersions(this.selectedRec.formId, index);
  }
  cancelVersionView(index) {
    this.closeVersionDropdown(null);
  }
  getFormVersions(formId, i) {
    this.versionsList = [];
    this.formsList = [];
    let obj = {
      formId: formId,
      group: this.groupName,
    };
    this.wfsService.getECFormsPublish(obj).then((data: any) => {
      this.formsList = data;
      this.versionsList = data.map((item) => ({
        uuid: item.publishId,
        version: item.version,
      }));
      this.showVersionDropdown[i] = true;
      this.showViewBtn[i] = true;
    });
  }
  closeVersionDropdown(versionIndex) {
    this.showVersionDropdown.forEach((item, index) => {
      if (versionIndex && versionIndex == index) {
        this.showVersionDropdown[index] = true;
        this.showViewBtn[index] = true;
      } else {
        this.showVersionDropdown[index] = false;
        this.showViewBtn[index] = false;
      }
    });
  }
  async getSelectedVersion(value) {
    let rec = this.formsList.find((item) => item.publishId == value);
    console.log("@@Rec:", rec);
    let obj = {
      publishId: value,
      version: rec.version,
      formId: rec.formId,
      group: this.groupName,
    };
    await this.wfsService.getFormsPublish(obj).then((data: any) => {
      this.workFlow = data[0];
      console.log("@@Workflow data:", this.workFlow);
    });
    this.showActiveStepper = true;
    this.type = "update";
    this.formsArray = [];
    this.registerFormObj = { orderId: null, ask: "", type: "" };
    this.registerGroup.reset();
    this.tableArray = [];
    this.showStepper = true;
    this.showActiveStepper = false;
    this.showDraftStepper = false;
    this.formTable = true;
    this.isFormBtn = [];
    this.showAddform = false;
    this.showAdd = false;
    this.showSavebtn = true;
    this.workFlowName = this.workFlow.name;
    this.workFlowDescription = this.workFlow.description;
    this.tableName = this.workFlow.tableName;
    this.url = this.globalImgUrl + this.workFlow.icon;
    this.imageUploadService = this.workFlow.icon;
    this.version = this.workFlow.version;
    this.formId = this.workFlow.formId;
    this.selectedUUID = this.workFlow["uuid"];
    for (var i = 0; i < this.workFlow.Forms.length; i++) {
      this.formsArray.push(this.workFlow.Forms[i]);
    }
    this.enableView = true;
  }
  addForms() {
    this.type = "save";
    this.formsArray = [];
    this.editRow = [];
    this.showStepper = true;
    this.showDraftStepper = true;
    this.workFlowName = "";
    this.workFlowDescription = "";
    this.tableName = "";
    this.showList = false;
    this.showAddform = true;
    this.isFormBtn = [];
    this.formTable = true;
    this.showSavebtn = true;
    this.showAdd = false;
    this.url = "";
    this.registerFormObj = { orderId: null, ask: "", type: "" };
    this.registerFormUpdateObj = {};
    // this.registerFormUpdateObj = {
    //   orderId: null,
    //   ask: "",
    //   type: "",
    //   kpiName: "",
    //   mandatory: false,
    //   className: "",
    //   formName: "",
    //   btnMetaData: "",
    //   repeatCount: 0,
    // };
    this.tableArray = [];
    this.readOnly = false;
  }
  addFormQtns() {
    this.editRow = [];
    this.isFormBtn = [];
    this.showAddform = true;
    this.formTable = true;
    this.showSavebtn = true;
    this.innerFormName = "";
    this.registerFormObj = {};
    this.registerFormUpdateObj = {};
    // this.registerFormUpdateObj = {
    //   orderId: null,
    //   ask: "",
    //   type: "",
    //   kpiName: "",
    //   mandatory: false,
    //   className: "",
    //   formName: "",
    //   btnMetaData: "",
    //   repeatCount: 0,
    // };
    this.tableArray = [];
  }

  backToView() {
    this.showStepper = false;
    this.showActiveStepper = false;
    this.showDraftStepper = false;
    this.showList = true;
    this.getAllActiveForms();
    this.getAllDraftForms();
  }
  secondStep() {
    if (this.formsArray.length > 0) {
      this.tableArray = [];
      this.formTable = false;
      this.isFormBtn = [];
      this.showAddform = false;
      this.showAdd = true;
    } else this.showAddform = false;
  }

  //delete selected image
  deleteImage() {
    this.url = "";
  }

  goToForm() {
    this.showAdd = true;
  }

  deleteForm(index) {
    this.formsArray.splice(index, 1);
  }

  addData(event) {
    console.log("event : ", event);
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  editForm(index, view) {
    this.type = "update";
    this.formsArray = [];
    this.readOnly = view == "active" ? true : false;
    this.registerFormObj = { orderId: null, ask: "", type: "" };
    this.registerGroup.reset();
    this.tableArray = [];
    this.showStepper = true;
    this.showDraftStepper = this.showDraftForms ? true : false;
    this.formTable = true;
    this.showList = false;
    this.isFormBtn = [];
    this.showAddform = false;
    this.showAdd = false;
    this.showSavebtn = true;
    this.workFlowName = this.draftFormsList[index].name;
    this.workFlowDescription = this.draftFormsList[index].description;
    this.tableName = this.draftFormsList[index].tableName;
    this.url = this.globalImgUrl + this.draftFormsList[index].icon;
    this.imageUploadService = this.draftFormsList[index].icon;
    this.version = this.draftFormsList[index].version;
    this.formId = this.draftFormsList[index].formId;
    this.selectedUUID = this.draftFormsList[index].uuid;
    for (var i = 0; i < this.draftFormsList[index].Forms.length; i++) {
      this.formsArray.push(this.draftFormsList[index].Forms[i]);
    }
    console.log("@@Forms array in edit:", this.formsArray);
  }
  viewData(index, view) {
    this.type = "update";
    this.readOnly = view == "active" ? true : false;
    this.registerFormObj = { orderId: null, ask: "", type: "" };
    this.registerGroup.reset();
    this.tableArray = [];
    this.showStepper = true;
    this.showDraftStepper = this.showDraftForms ? true : false;
    this.formTable = true;
    this.showList = false;
    this.isFormBtn = [];
    this.showAddform = false;
    this.showAdd = false;
    this.showSavebtn = true;
    this.closeVersionDropdown(null);
  }
  updateRow(index) {
    this.btnDone = true;
    this.editRowIndex = index;
    this.disableFormsBtn = false;
    this.kpinameHead = false;
    this.showKpiNameUpdate = [];
    if (this.registerFormUpdateObj.type == "singleSelect" || this.registerFormUpdateObj.type == "multiSelect" || this.registerFormUpdateObj.type == "dropdown") {
    }
    let i = this.tableArray.findIndex((x) => x.orderId == this.registerFormUpdateObj.orderId);
    if (i === index) {
      this.editRow = [];
      this.editRow[index] = false;
      if (this.selectedClass) {
        delete this.selectedClass._id;
        delete this.selectedClass.createTs;
        delete this.selectedClass.updateTs;
        this.registerFormUpdateObj["classId"] = this.selectedClassId;
        this.registerFormUpdateObj["classVersion"] = this.selectedClassVersion;
        this.registerFormUpdateObj['memberMetadata'] = this.selectedMember.metaData;
        this.registerFormUpdateObj['memberOptions'] = this.listOptions;
        console.log('@@Selected list id:', this.selectedList, this.selectedListId);
        if (this.selectedListId) {
          this.registerFormUpdateObj['listId'] = this.selectedListId;
        }
        if (this.selectedList && this.selectedList.dependentOn) {
          this.registerFormUpdateObj['dependentOn'] = this.selectedList.dependentOn;
          this.registerFormUpdateObj['memberOptions'] = null;
          let index = this.tableArray.findIndex(obj => obj.listId === this.selectedList.dependentOn.uuid && obj.memberMetadata === this.selectedList.dependentOn.name);
          console.log('index', index);
          if (index != -1) {
            if (this.tableArray[index].dependencies && this.tableArray[index].dependencies.length > 0) {
              this.tableArray[index].dependencies.push({ kpiName: this.registerFormUpdateObj['kpiName'], listId: this.selectedListId });
            } else {
              this.tableArray[index].dependencies = [{ kpiName: this.registerFormUpdateObj['kpiName'], listId: this.selectedListId }];
            }
          }
        }
      }
      if (this.registerFormUpdateObj['form']) {
        this.registerFormUpdateObj['formId'] = this.selectedInnerFormId;
        this.registerFormUpdateObj['formVersion'] = this.selectedInnerFormVersion;
      }
      if (this.registerFormUpdateObj['formName']) {
        // let formName = "Plantation, plantation:1|Transplanted, Transplanted:1|SeedSown, SeedSown:1"
        let formName = this.registerFormUpdateObj['formName'];
        let arr1 = formName.split('|');
        console.log('arr1', arr1);
        arr1.forEach((item, index) => {
          let arr2 = item.split(',');
          let mainName = arr2[0];
          let arr3 = arr2[1].trim().split(':');
          let subName = arr3[0];
          let version = arr3[1];
          let tempForm = this.workflows.find(
            (item) => item.name == subName && item.version == version
          );
          console.log(formName, arr1, arr2, arr3, mainName, subName, version, tempForm)
          if (tempForm) {
            delete tempForm._id;
            delete tempForm.createTs;
            delete tempForm.updateTs;
            this.registerFormUpdateObj[mainName] = tempForm;
          }
        });
      }
      this.tableArray[index] = this.registerFormUpdateObj;
      this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      console.log("@@Table array:", this.tableArray);
      this.registerFormUpdateObj = {};
      // this.registerFormUpdateObj = {
      //   orderId: null,
      //   ask: "",
      //   type: "",
      //   kpiName: "",
      //   mandatory: false,
      //   className: "",
      //   formName: "",
      //   btnMetaData: "",
      //   repeatCount: 0,
      // };
    } else if (i === -1) {
      this.editRow = [];
      this.editRow[index] = false;
      this.tableArray[index] = this.registerFormUpdateObj;
      this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
      this.registerFormUpdateObj = {};
      // this.registerFormUpdateObj = {
      //   orderId: null,
      //   ask: "",
      //   type: "",
      //   kpiName: "",
      //   mandatory: false,
      //   className: "",
      //   formName: "",
      //   btnMetaData: "",
      //   repeatCount: 0,
      // };
    } else {
      Swal.fire("Error", "Order Id is already exist", "error");
    }
  }
  getMandatoryValue(value) {
    console.log("@Mandatory value:", value);
  }
  getTableViewValue(value) {
    console.log("@@Table view value:", value);
    // this.registerFormUpdateObj.tableView = value;
  }
  deleteRow(form, index) {
    Swal.fire({
      title: 'Are you sure you want to Delete?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((value: any) => {
      if (value.value) {
        if (form.dependentOn) {
          let formIndex = this.tableArray.findIndex(obj => obj.listId === form.dependentOn.uuid && obj.kpiName === form.dependentOn.name);
          this.tableArray[formIndex].dependencies = this.tableArray[formIndex].dependencies.filter(item => item.listId != form.listId || item.kpiName != form.kpiName);
        }
        this.tableArray.splice(index, 1);
        console.log(this.tableArray);
        Swal.fire({ title: "Deleted successfully" });
      }
    });
  }
  insertIntoTable() {
    console.log("@@Register form obj in insertIntoTable:", this.registerFormObj);
    if (this.registerFormObj["type"] == "iterativeForm") {
      delete this.registerFormObj["className"];
      delete this.registerFormObj["memberName"];
    }
    this.tempArray = [];
    if (this.kpiName != null && this.kpiName != "" && this.kpiName != undefined) {
      this.registerFormObj["kpiName"] = this.kpiName;
      if (this.selectedClass) {
        delete this.selectedClass._id;
        delete this.selectedClass.createTs;
        delete this.selectedClass.updateTs;
        this.registerFormObj["classId"] = this.selectedClassId;
        this.registerFormObj["classVersion"] = this.selectedClassVersion;
        this.registerFormObj["memberMetadata"] = this.selectedMember.metaData;
        this.registerFormObj["memberOptions"] = this.listOptions;
        console.log("@@Selected list id:", this.selectedListId);
        if (this.selectedListId) {
          this.registerFormObj["listId"] = this.selectedListId;
        }
        console.log("selectedList", this.selectedList)
        if (this.selectedList && this.selectedList.dependentOn && this.selectedList.dependentOn.uuid) {
          this.registerFormObj['dependentOn'] = this.selectedList.dependentOn;
          this.registerFormObj['memberOptions'] = null;
          let index = this.tableArray.findIndex(obj => obj.listId === this.selectedList.dependentOn.uuid && obj.memberMetadata === this.selectedList.dependentOn.name);
          console.log('index', index);
          if (index != -1) {
            if (this.tableArray[index].dependencies && this.tableArray[index].dependencies.length > 0) {
              this.tableArray[index].dependencies.push({ kpiName: this.registerFormObj['kpiName'], listId: this.selectedListId });
            } else {
              this.tableArray[index].dependencies = [{ kpiName: this.registerFormObj['kpiName'], listId: this.selectedListId }];
            }
          }
        }
      }
      if (this.registerFormObj["form"]) {
        this.registerFormObj["formId"] = this.selectedInnerFormId;
        this.registerFormObj["formVersion"] = this.selectedInnerFormVersion;
      }
      if (this.registerFormObj["formName"]) {
        // let formName = "Plantation, plantation:1|Transplanted, Transplanted:1|SeedSown, SeedSown:1"
        let formName = this.registerFormObj["formName"];
        let arr1 = formName.split("|");
        console.log('arr1', arr1);
        arr1.forEach((item, index) => {
          let arr2 = item.split(",");
          let mainName = arr2[0];
          let arr3 = arr2[1].trim().split(":");
          let subName = arr3[0];
          let version = arr3[1];
          let tempForm = this.workflows.find(
            (item) => item.name == subName && item.version == version
          );
          if (tempForm) {
            delete tempForm._id;
            delete tempForm.createTs;
            delete tempForm.updateTs;
            this.registerFormObj[mainName] = tempForm;
          }
        });
      }
      let index = this.tableArray.findIndex(
        (x) => x.orderId == this.registerFormObj["orderId"]
      );
      let KPI = this.tableArray.findIndex(
        (x) => x.kpiName == this.registerFormObj["kpiName"]
      );
      console.log("KPI ", KPI);
      if (index === -1 && KPI === -1) {
        this.tableArray.push(this.registerFormObj);
        this.tableArray.sort((a, b) => Number(a.orderId) - Number(b.orderId));
        this.registerFormObj = {};
        this.registerGroup.reset();
        this.showKpiName = true;
        this.registerFormObj["orderId"] = this.tableArray.length + 1;
        this.showClassInput = true;
        this.showFormInput = false;
        this.showButtonInput = false;
      } else {
        Swal.fire("Error", "Order Id or Kpi name is already exist", "error");
      }
      this.listGenerated = false;
      this.selectedList = [];
    } else {
      Swal.fire("Error", "Add kpi name", "error");
    }
  }
  editRowData(index) {
    console.log("@Edit row data:", index);
    this.btnDone = true;
    this.showKpiNameUpdate = [];
    this.kpinameHead = false;
    this.disableFormsBtn = true;
    console.log("@tableArray[index]", this.tableArray[index]);
    if (this.tableArray[index].kpi) {
      this.showKpiNameUpdate[index] = true;
      this.kpinameHead = true;
    }
    this.registerFormUpdateObj = {};
    // this.registerFormUpdateObj = {
    //   orderId: null,
    //   ask: "",
    //   type: "",
    //   mandatory: false,
    //   kpiName: "",
    //   className: "",
    //   formName: "",
    //   btnMetaData: "",
    //   repeatCount: 0,
    //   tableView: false,
    // };
    this.registerGroup.reset();
    this.editRow = [];
    // this.editRow[index] = true;
    this.editRowIndex = index;
    this.registerFormUpdateObj['classId'] = this.tableArray[index].classId ? this.tableArray[index].classId : '';
    this.registerFormUpdateObj['listId'] = this.tableArray[index].listId ? this.tableArray[index].listId : '';
    this.getSelectedClass(this.tableArray[index].className);
    this.getSelectedMember(this.tableArray[index].memberName);
    this.registerFormUpdateObj["classId"] = this.tableArray[index].classId ? this.tableArray[index].classId : "";
    if (this.tableArray[index].classId) {
      this.getSpecificClass(this.registerFormUpdateObj["classId"], this.tableArray[index], index);
    } else {
      this.getSpecificClass("", this.tableArray[index], index);
    }
  }

  cancelRowEdit(index) {
    this.showKpiNameUpdate = [];
    this.disableFormsBtn = false;
    this.kpinameHead = false;
    this.editRow = [];
    this.editRow[index] = false;
    this.editRowIndex = index;
  }

  saveForm() {
    this.form = this.tableArray;
    let finalArray = {
      formName: this.innerFormName,
      forms: this.tableArray,
    };
    this.formsArray.push(finalArray);
    this.tableArray = [];
    finalArray = { formName: "", forms: [] };
    this.formTable = false;
    this.isFormBtn = [];
    this.editRow = [];
    this.showKpiNameUpdate = [];
    this.innerFormName = "";
    this.editRow[this.editRowIndex] = false;
    this.showKpiNameUpdate[this.editRowIndex] = false;
    this.kpinameHead = false;
    this.showAddform = false;
    this.showAdd = true;
  }

  removeTable() {
    this.registerFormObj = { orderId: null, ask: "", type: "" };
    this.registerGroup.reset();
    this.showKpiName = false;
  }
  openForms(form, index) {
    let forms = form.forms;
    this.innerFormName = form.formName;
    this.isFormBtn = [];
    this.tableArray = forms;
    this.showAddform = true;
    this.formTable = true;
    this.disableFormsBtn = false;
    this.index = index;
    this.isFormBtn[this.index] = true;
    this.registerFormObj["orderId"] = this.tableArray.length + 1;
    this.showSavebtn = false;
  }
  backToAddForm(form) {
    this.showAddform = false;
    this.formTable = false;
    this.registerFormUpdateObj = {};
    // this.registerFormUpdateObj = {
    //   orderId: null,
    //   ask: "",
    //   type: "",
    //   mandatory: false,
    //   kpiName: "",
    //   className: "",
    //   formName: "",
    //   tableView: false,
    // };
    this.registerFormObj = {};
    this.tableArray = [];
    this.registerGroup.reset();
  }
  generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    var first = ("000" + firstPart.toString(36)).slice(-3);
    var second = ("000" + secondPart.toString(36)).slice(-3);
    return first + second;
  }
  submitAllForm() {
    this.loading = true;
    this.btnLoading = true;
    this.tableArray = [];
    this.isFormBtn = [];
    this.formTable = false;
    this.showSavebtn = false;
    this.workFlow = {
      group: this.groupName,
      name: this.workFlowName,
      description: this.workFlowDescription,
      tableName: this.tableName,
      icon: this.imageUploadService,
      Forms: this.formsArray,
      version: 1,
      formId: UUID.UUID(),
    };
    this.workFlow["uuid"] = UUID.UUID();
    if (this.registerIcon != undefined) {
      this.uploadFileToActivity();
    }
    this.wfsService.saveClassFormsDraft(this.workFlow).then((data: any) => {
      this.btnLoading = false;
      if (data) {
        this.publishForm(this.workFlow);
        this.loading = false;
        this.showStepper = false;
        this.showActiveStepper = false;
        this.showDraftStepper = false;
        this.formsArray = [];
        this.tableArray = [];
        this.url = "";
        this.workFlowDescription = "";
        this.tableName = "";
        this.showList = true;
        this.disableFormsBtn = false;
        this.getAllActiveForms();
        this.getAllDraftForms();
      } else {
        this.btnLoading = true;
        this.loading = false;
        Swal.fire(
          "Error",
          "Data not Submitted (please contact admin)",
          "error"
        );
      }
    });
  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + "agri_logo.png";
  }
  getAllClasses() {
    this.loading = true;
    let obj = {
      // group: this.groupName,
    };
    this.wfsService.getAllDraftClasses(obj).then((data: any) => {
      if (data.length > 0) {
        this.classesList = data.sort();
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
  getSpecificClass(id, rec, index) {
    console.log("id,class,index", id, rec, index)
    if (id) {
      this.wfsService.getSpecificClasses(id).then((data: any) => {
        if (data.length > 0) {
          this.selectedClass = data[0];
          this.selectedClassId = data[0].classId;
          this.selectedClassVersion = data[0].version;
          this.selectedListId = rec.listId;
          this.members = [];
          this.members = data[0].members;
          this.members.unshift("Select Member");
          this.registerFormUpdateObj.orderId = rec.orderId;
          this.registerFormUpdateObj.ask = rec.ask;
          this.registerFormUpdateObj['kpiName'] = rec.kpiName;
          this.registerFormUpdateObj.type = rec.type;
          this.registerFormUpdateObj.mandatory = rec.mandatory;
          if (rec.type != 'button' && rec.type != 'repeat' && rec.type != 'innerForm' && rec.type != 'iterativeForm') {
            this.registerFormUpdateObj['memberName'] = rec.memberName ? rec.memberName : '';
            this.registerFormUpdateObj['memberOptions'] = rec.memberOptions ? rec.memberOptions : [];
            this.registerFormUpdateObj['memberMetadata'] = rec.memberMetadata ? rec.memberMetadata : '';
            this.registerFormUpdateObj['listId'] = rec.listId ? rec.listId : '';

            this.registerFormUpdateObj.className = rec.className ? rec.className : '';
            this.registerFormUpdateObj.classId = rec.className ? rec.classId : '';
            this.registerFormUpdateObj.classVersion = rec.classVersion ? rec.classVersion : '';
          }
          if (rec.formName) {
            this.registerFormUpdateObj.formName = rec.formName;
          }
          if (rec.type == 'repeat') {
            this.registerFormUpdateObj.repeatCount = rec.repeatCount;
          }
          if (rec.type == 'button') {
            this.registerFormUpdateObj.btnMetaData = rec.btnMetaData;
          }
          if (rec.type == 'label') {
            this.registerFormUpdateObj.tableView = rec.tableView;
          }
          this.editRow[index] = true;
          this.editRow[index] = true;
          console.log("@@Register form update obj:", this.registerFormUpdateObj);
        } else {
          this.loading = false;
        }
      });
    } else {
      this.registerFormUpdateObj.orderId = rec.orderId;
      this.registerFormUpdateObj.ask = rec.ask;
      this.registerFormUpdateObj['kpiName'] = rec.kpiName;
      this.registerFormUpdateObj.type = rec.type;
      this.registerFormUpdateObj.mandatory = rec.mandatory;
      if (rec.type != 'button' && rec.type != 'repeat' && rec.type != 'innerForm' && rec.type != 'iterativeForm') {
        this.registerFormUpdateObj['memberName'] = rec.memberName ? rec.memberName : '';
        this.registerFormUpdateObj['memberOptions'] = rec.memberOptions ? rec.memberOptions : [];
        this.registerFormUpdateObj['memberMetadata'] = rec.memberMetadata ? rec.memberMetadata : '';
        this.registerFormUpdateObj['listId'] = rec.listId ? rec.listId : '';

        this.registerFormUpdateObj.className = rec.className ? rec.className : '';
        this.registerFormUpdateObj.classId = rec.className ? rec.classId : '';
        this.registerFormUpdateObj.classVersion = rec.classVersion ? rec.classVersion : '';
      }
      if (rec.formName) {
        this.registerFormUpdateObj.formName = rec.formName;
      }
      if (rec.type == 'repeat') {
        this.registerFormUpdateObj.repeatCount = rec.repeatCount;
      }
      if (rec.type == 'button') {
        this.registerFormUpdateObj.btnMetaData = rec.btnMetaData;
      }
      if (rec.type == 'label') {
        this.registerFormUpdateObj.tableView = rec.tableView;
      }
      this.editLoading[index] = false;
      this.editRow[index] = true;
      console.log('@@Register form update obj:', this.registerFormUpdateObj);
      this.loading = false;
    }
  }
  getSelectedClass(rec) {
    this.members = [];
    this.selectedClass = this.classesList.filter((item) => item.name == rec)[0];
    this.members = this.selectedClass.members;
    console.log('@@Members before unshift:', this.members);
    if (this.members[0] != 'Select Member') {
      this.members.unshift('Select Member');
    }
    console.log('@@Members after unshift:', this.members);
    this.selectedClassId = this.selectedClass.classId;
    this.selectedClassVersion = this.selectedClass.version;
  }
  getSelectedForm(rec) {
    this.members = [];
    this.selectedInnerForm = this.draftFormsList.filter((item) => item.name == rec)[0];
    this.selectedInnerFormId = this.selectedInnerForm.formId;
    this.selectedInnerFormVersion = this.selectedInnerForm.version;
  }
  getSelectedMember(rec) {
    console.log('@@Selected member name:', rec);
    this.selectedMember = this.members.filter((item) => item.name == rec)[0];
    console.log('@@Selected member:', this.selectedMember);
    if (this.selectedMember.listId) {
      this.selectedListId = this.selectedMember.listId;
      this.getSelectedList(this.selectedListId);
    } else {
      this.listGenerated = true;
      this.selectedList = [];
      this.listOptions = [];
    }
  }
  getSelectedList(id) {
    this.selectedList = [];
    this.listOptions = [];
    console.log('@@Selected list id:', id);
    this.wfsService.getSpecificList(id).then((data: any) => {
      this.selectedList = data[0];
      if (this.selectedList.url) {
        this.getData(this.selectedList.url).then((data: any) => {
          console.log('@@List reponse:', data);
          this.listOptions = data;
          this.listGenerated = true;
        });
      }
      console.log('@@Selected list data:', this.selectedList);
      if (this.selectedList.type == 'parameterisedRest') {
        this.showParameter = true;
      } else {
        this.showParameter = false;
      }
    });
  }
  getData(url) {
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe((res: any) => {
        // console.log("inside getData", res)
        resolve(res);
      });
    });
  }
  registerForms() {
    this.showList = false;
  }
  changeAskType(e) {
    if (e == "multiForm") {
      this.showFormInput = true;
      this.showClassInput = true;
      this.showRepeatCount = false;
      this.showIterativeForm = false;
      this.showParameter = false;
    } else if (e == "button") {
      this.showFormInput = false;
      this.showClassInput = false;
      this.showButtonInput = true;
      this.showRepeatCount = false;
      this.showIterativeForm = false;
      this.showParameter = false;
    } else if (e == "repeat") {
      this.showFormInput = false;
      this.showClassInput = false;
      this.showIterativeForm = false;
      this.showRepeatCount = true;
      this.showParameter = false;
    } else if (e == "iterativeForm" || e == "innerForm") {
      this.showIterativeForm = true;
      this.showFormInput = false;
      this.showClassInput = false;
      this.showRepeatCount = false;
      this.showParameter = false;
    } else {
      this.showFormInput = false;
      this.showButtonInput = false;
      this.showClassInput = true;
      this.showRepeatCount = false;
      this.showIterativeForm = false;
      this.showParameter = false;
    }
  }
  changeAskTypeOnEdit(e) {
    if (e == "iterativeForm" || e == "innerForm") {
      this.showIterativeForm = true;
      this.showFormInput = false;
      this.showClassInput = false;
      this.showRepeatCount = false;
    }
  }
  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => {
        // called once readAsDataURL is completed
        this.url = event.target.result;
      };
      let iuuid = UUID.UUID();
      this.imageUploadService =
        "reg_" + iuuid + "." + event.target.files.item(0).type.split("/")[1];
      this.registerIcon = event.target.files[0];
    }
  }
  uploadFileToActivity() {
    if (this.registerIcon != "") {
      this.fileUploadService.uploadFile(this.registerIcon, this.imageUploadService);
    }
  }
  updateForm() {
    this.form = this.tableArray;
    let finalArray = {
      formName: this.innerFormName,
      forms: this.tableArray,
    };
    // this.formsArray[this.index] = this.form;
    this.formsArray[this.index] = finalArray;
    this.tableArray = [];
    finalArray = { formName: "", forms: [] };
    this.showAddform = false;
    this.formTable = false;
    this.isFormBtn = [];
    this.editRow = [];
    this.showKpiNameUpdate = [];
    this.editRow[this.editRowIndex] = false;
    this.showKpiNameUpdate[this.editRowIndex] = false;
    this.kpinameHead = false;
  }
  hideForm() {
    this.showAddform = false;
    this.formTable = false;
  }
  closeForm() {
    this.showStepper = false;
    this.showActiveStepper = false;
    this.showDraftStepper = false;
    this.showList = true;
    this.getAllDraftForms();
  }
  submitUpdateForm() {
    if (this.registerIcon != undefined) {
      this.uploadFileToActivity();
    }
    this.btnLoading = true;
    this.loading = true;
    this.tableArray = [];
    this.isFormBtn = [];
    this.formTable = false;
    this.showSavebtn = false;
    this.workFlow = {
      group: this.groupName,
      name: this.workFlowName,
      description: this.workFlowDescription,
      icon: this.imageUploadService,
      tableName: this.tableName,
      // language: language,
      Forms: this.formsArray,
      version: ++this.version,
      formId: this.formId,
    };
    this.workFlow["uuid"] = this.selectedUUID;
    delete this.workFlow["id"];
    this.wfsService
      .updateClassFormsDraft(this.workFlow, this.selectedUUID)
      .then((data: any) => {
        this.btnLoading = false;
        if (data) {
          Swal({ title: "Updated successfully" });
          this.loading = false;
          this.showStepper = false;
          this.showActiveStepper = false;
          this.showDraftStepper = false;
          this.formsArray = [];
          this.tableArray = [];
          this.showList = true;
          this.url = "";
          this.workFlowDescription = "";
          this.disableFormsBtn = false;
          this.publishForm(this.workFlow);
          this.getAllActiveForms();
          this.getAllDraftForms();
        } else {
          this.btnLoading = false;
          this.loading = false;
          Swal.fire(
            "Error",
            "Data not Submitted (please contact admin)",
            "error"
          );
        }
      });
  }
  publishForm(rec) {
    rec["publishId"] = UUID.UUID();
    console.log("@@Publish form before request:", JSON.stringify(rec));
    this.wfsService.saveFormsPublish(rec).then((data: any) => {
      if (data) {
        console.log("@@Form published");
      }
    });
  }
}
